/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useMedia } from "react-use";
import { Tooltip } from "@mui/material";
import { Backdrop } from "@mui/material";
import { QuickSearch } from "cms/search/quick-search/quick-search";
import { WebsiteLogo } from "layout-components/header/logo";
import { MyDnv } from "mydnv/components/sign-in";
import { WhenSignedIn } from "mydnv/components/sign-in/sign_in_out_util";
import { useMyDNVContext } from "mydnv/context/mydnv-context";
import { WrappedBookmark } from "mydnv/components/bookmark/wrapped-bookmark";

const TopBar = () => {
    const isDesktop = useMedia("screen and (min-width: 1125px)");
    // const isTablet = useMedia("screen and (max-width: 1060px)");
    // const isMobile = useMedia("screen and (max-width: 480px)");
    const { emailVerified, bookmarks, showBookmarksTip, setShowBookmarksTip,setShowVerifiedTip } = useMyDNVContext();
    const notDesktop = !isDesktop;
    const parsedBookmarks = bookmarks !== undefined ? JSON.parse(bookmarks) : [];

    const tooltipRef = useRef(null);

    const handleTooltipClose = () => {
        setShowBookmarksTip(false);
        if (localStorage.getItem("not-signedin-bookmark") !== null) {
            setShowVerifiedTip(true);
            localStorage.removeItem("not-signedin-bookmark");
        }
    };

    useEffect(() => {
        if (tooltipRef.current) {
            if (showBookmarksTip) {
                tooltipRef.current.focus();
            }
        }
    }, [showBookmarksTip]);

    return (
        <div className="top-bar">
            {isDesktop && <a href="#skip-content-start" className="skip-link desktop">Skip to main content</a>}
            <div className="top-bar-content-wrapper">
                {isDesktop && (
                    <div className="top-bar-logo">
                        <WebsiteLogo />
                    </div>
                )}
                <div className="top-bar-content">
                    {/* for mobile */}
                    <ul className="top-bar-left" style={notDesktop ? { display: "flex" } : { display: "none" }}>
                        <li>
                            <Link
                                to="/government-administration/report-problem"
                                title="Report a Problem"
                                className="topbar-button"
                            >
                                {/* {isTablet && !isMobile && <FontAwesomeIcon icon={faTriangleExclamation} />} */}
                                Report a Problem
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/government-administration/contact-us"
                                title="Contact Us"
                                className="topbar-button"
                            >
                                Contact Us
                            </Link>
                        </li>
                    </ul>

                    <ul className="myDNV">
                        {/* first 2 <li> for desktop to allow search container to stretch to 400px */}
                        <li>
                            <Link
                                to="/government-administration/report-problem"
                                title="Report a Problem"
                                className="topbar-button"
                            >
                                Report a Problem
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/government-administration/contact-us"
                                title="Contact Us"
                                className="topbar-button"
                            >
                                Contact Us
                            </Link>
                        </li>
                        <li style={{ width: "100%", maxWidth: "400px" }}>
                            <QuickSearch />
                        </li>

                        <WhenSignedIn>
                            {emailVerified && isDesktop && (
                                <li className={parsedBookmarks.length === 0 ? "hidden" : ""}>
                                    <Tooltip
                                        ref={tooltipRef}
                                        classes={{ popper: "bookmarks-tooltip" }}
                                        open={showBookmarksTip}
                                        disableFocusListener
                                        disableHoverListener
                                        disableTouchListener
                                        arrow
                                        slotProps={{
                                            popper: {
                                                disablePortal: true,
                                                role: "dialog",
                                            },
                                        }}
                                        title={
                                            <React.Fragment>
                                                <h4>New bookmark</h4>
                                                <p>Quickly access your bookmarked pages from one place.</p>
                                                <button title="Close tooltip" onClick={handleTooltipClose}>
                                                    Ok, got it
                                                </button>
                                            </React.Fragment>
                                        }
                                        placement="bottom-start"
                                    >
                                        <WrappedBookmark className="btn btn-bookmark topbar-button" />
                                    </Tooltip>

                                    <Backdrop
                                        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
                                        open={showBookmarksTip}
                                    ></Backdrop>
                                </li>
                            )}
                        </WhenSignedIn>

                        <li>{isDesktop && <MyDnv />}</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export { TopBar };
